import { useState } from "react";
import { Button } from "react-bootstrap";

export const ButtonChoiceQuestion = (props : { question, rightAnswer, wrongAnswer, evaluated }) => {
  const [answeredId, setAnsweredId] = useState(0)

  const checkAnswer = (answerId) => {
    setAnsweredId(answerId);
    if (answerId === props.question.correct) {
      props.rightAnswer();
    } else {
      props.wrongAnswer();
    }
  }

  /*if (!props.evaluated && answeredId !== 0) {
    setAnsweredId(0);
  }*/

  const buttons = props.question.answers.map((answer) => {
    const clicked = () => {
      if (!props.evaluated) {
        checkAnswer(answer.id)
      }
    }

    let variant = "light";
    if (props.evaluated && answeredId === answer.id && answeredId === props.question.correct) {
      variant = "success";
    } else if (props.evaluated && answeredId === answer.id) {
      variant = "danger";
    }

    return (<Button variant={variant} size="lg" key={answer.id} onClick={clicked}>
        { answer.text }
    </Button>);
  })

  return (<>
    <h3 className="text-center mb-5">{props.question.question}</h3>
    <div className="d-grid gap-2">
      { buttons }
    </div>
  </>);
}
